export enum UserPinType {
  ASSESSMENT = 'assessment',
  TEST = 'test',
  SIMULATION = 'simulation',
  CHARACTER = 'character',
  ENVIRONMENT = 'environment',
}

export interface UserPin {
  id?: string
  userId: string
  workspaceId: string
  path: string
  type: UserPinType
  title: string
  createdAt?: string
  updatedAt?: string
  deletedAt?: string
}
